import { useSelector } from "react-redux";

export const useOverrideToggle = () => {
  const tissueOverrideStatus = useSelector((state) => state.patient.tissueOverrideStatus);

  return tissueOverrideStatus === 1;
};
